import logo from "assets/images/sportswear-erp.png";
import Avatar from "assets/images/users/avatar-1.jpg";
import { Link, useLocation, useParams } from "react-router-dom";
import { portalPath } from "./portalApi";

// Customer portal shell (user, 2026-11-05: "Sidebar like the main app, with
// no modules showing"). Same leftside-menu markup and classes as
// components/NavBar.js so it looks like the staff app; the menu has only
// Home until portal modules exist.
function PortalLayout({ me, onLogout, children }) {
  const { companyId } = useParams();
  const { pathname } = useLocation();
  const home = portalPath(companyId);
  const name =
    [me?.contact?.firstName, me?.contact?.lastName].filter(Boolean).join(" ") ||
    me?.contact?.email;

  return (
    <div className="wrapper">
      <div style={{ zIndex: 99999 }} className="leftside-menu">
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ height: 156 }}
        >
          <Link to={home}>
            <div className="mt-2 d-flex justify-content-center align-items-center">
              <img src={logo} alt="logo" height="100px" width="150px" />
            </div>
          </Link>
          <div className="text-white mt-2 px-2 text-center">
            <h5 className="m-0">{me?.company?.name}</h5>
          </div>
        </div>

        <div id="leftside-menu-container">
          <ul
            className="side-nav scrollbar-hide"
            style={{ height: "calc(100vh - 156px)", overflow: "auto" }}
          >
            <li className="side-nav-item">
              <div className="d-flex align-items-center side-nav-link" title={me?.contact?.email}>
                <span className="account-user-avatar">
                  <img
                    src={Avatar}
                    alt={name}
                    className="rounded-circle me-1"
                    height={30}
                    width={30}
                  />
                </span>
                <span className="text-white text-uppercase flex-grow-1">{name}</span>
              </div>
            </li>

            <li className="side-nav-title side-nav-item">Navigation</li>
            <li className="side-nav-item">
              <Link
                to={home}
                className={`side-nav-link ${pathname === home ? "text-warning" : ""}`}
              >
                <i className="mdi mdi-home"></i>
                <span> Home </span>
              </Link>
            </li>
            <li className="side-nav-item">
              <button
                type="button"
                onClick={onLogout}
                className="side-nav-link btn btn-link text-start w-100 border-0 shadow-none"
              >
                <i className="mdi mdi-logout"></i>
                <span> Logout </span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div style={{ minHeight: "100vh", backgroundColor: "#f0f4f9" }}>
        <div className="content">{children}</div>
      </div>
    </div>
  );
}

export default PortalLayout;
